module.exports = __webpack_public_path__ + "images/icon-499f6330.png";